import { render } from "./TheControlSidebar.vue?vue&type=template&id=47d0b1fa"
import script from "./TheControlSidebar.vue?vue&type=script&lang=js"
export * from "./TheControlSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__